import request from '@/utils/request'

// 用户关联采购人公司（功能一）
export function getComListByUser (params) {
  return request({ url: '/xtgl/usercomrel/getComListByUser', method: 'get', params })
}

export function getRelComList (params) {
  return request({ url: '/xtgl/usercomrel/getRelComList', method: 'get', params })
}

export function addRel (data) {
  return request({ url: '/xtgl/usercomrel/addRel', method: 'post', data })
}

export function cancelRel (data) {
  return request({ url: '/xtgl/usercomrel/cancelRel', method: 'post', data })
}

// 采购人关联设置页：当前登录单位下所有人员
export function getUserList (params) {
  return request({ url: '/xtgl/usercomrel/getUserList', method: 'get', params })
}
